export default [
  {
    path: '/activity/index',
    component: () => import('../../views/activity/index.vue'),
    name: 'activity-index',
    meta: {
      auth: 0,
      title: '看看你有多少核能量',
    },
  },
  {
    auth: 0,
    path: '/activity/login',
    component: () => import('../../views/activity/login.vue'),
    name: 'activity-login',
    meta: {
      title: '看看你有多少核能量',
    },
  },
  {
    auth: 0,
    path: '/activity/deactive',
    component: () => import('../../views/activity/deactive.vue'),
    name: 'activity-deactive',
    meta: {
      title: '看看你有多少核能量',
    },
  },
  {
    auth: 0,
    path: '/activity/active',
    component: () => import('../../views/activity/active.vue'),
    name: 'activity-active',
    meta: {
      title: '看看你有多少核能量',
    },
  },
];
